import React from "react";
import { StyledFilterDashboard } from "./styles";

const FilterDashboard = ({ children, name }) => {
  return (
    <StyledFilterDashboard>
      {name} {children}
    </StyledFilterDashboard>
  );
};

export default FilterDashboard;
